import React from "react";

interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ searchQuery, onSearchChange }) => {
  return (
    <div className="relative">
      <input
        className="block w-full p-3 pl-10 rounded-lg bg-blue-50 text-sm text-grease-100 placeholder-gray-400 focus:outline-none"
        placeholder="Search by keyword"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
      />
    </div>
  );
};

export default SearchBar;
